import * as Button from './Button';
import * as CheckBox from './CheckBox';
import Code from './Code';
import Comparator from './Comparator';
import Datalist from './Datalist';
import * as Date from './Date';
import Enumeration from './Enumeration';
import FieldTemplate, { TextModeTemplate } from './FieldTemplate';
import File from './File';
import KeyValue from './KeyValue';
import ListView from './ListView';
import MultiSelectTag from './MultiSelectTag';
import NestedListView from './NestedListView';
import RadioOrSelect from './RadioOrSelect';
import Radios from './Radios';
import ResourcePicker from './ResourcePicker';
import Select from './Select';
import Text from './Text';
import TextArea from './TextArea';
import TimezoneList from './TimezoneList';
import Toggle from './Toggle';

export default {
	Button,
	CheckBox,
	Code,
	Comparator,
	Datalist,
	Date,
	Enumeration,
	FieldTemplate,
	File,
	KeyValue,
	ListView,
	MultiSelectTag,
	NestedListView,
	RadioOrSelect,
	Radios,
	ResourcePicker,
	Select,
	Text,
	TextArea,
	TextModeTemplate,
	TimezoneList,
	Toggle,
};
